import { Controller } from "@hotwired/stimulus"

// Keeps a FormFilters::SortDropdown button naming the live choice ("Sort:
// Name", "Group: Person"). Its radios usually only reload a results
// turbo-frame (frame-filter), and the button sits outside that frame, so the
// server never re-renders it - without this it keeps naming the choice the
// page loaded with (TASK-292.7).
export default class extends Controller {
  static targets = ["choice"]
  static values = { prefix: String }

  pick(event) {
    const label = event.target.dataset.optionLabel
    if (label && this.hasChoiceTarget) this.choiceTarget.textContent = `${this.prefixValue}: ${label}`
  }
}
